import request from '@/utils/request'

// ---------------------- 监管机构 --------------------------
/**
 * @describe 分页查看监管机构
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param regName 监管机构名称
 * @param regLevel 机构级别
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageRegulator(query) {
	return request({
		url: 'reg/pageRegulator.do',
		method: 'GET',
		params: query
	})
}


/**
 * @describe 获取一个监管机构（包含机构下的人员）
 * @param regId
 */
export function getOneRegulator(query) {
	return request({
		url: 'reg/getOneRegulator.do',
		method: 'GET',
		params: query
	})
}


/**
 * @describe 新增一个监管机构
 * @param  regName 机构名称
 * @param  regLevel 机构级别
 * @param  person 负责人
 * @param  phone 联系电话
 * @param  address 地址
 * @param  areaCodeCity 地区编码-市
 * @param  areaCodeDistrict 地区编码-区
 * @param  areaCodeSubdistrict 地区编码-街道
 * @param  villageCode 地区编码-村
 */
export function saveRegulator(query) {
	return request({
		url: 'reg/saveRegulator.do',
		method: 'POST',
		data: query
	})
}

/**
 * @describe 修改一个监管机构
 * @param regId
 * @param 同上
 */
export function editRegulator(query) {
	return request({
		url: 'reg/editRegulator.do',
		method: 'POST',
		data: query
	})
}


/**
 * @describe 删除一个监管机构
 * @param patrolId
 */
export function delRegulator(query) {
	return request({
		url: 'reg/delRegulator.do',
		method: 'POST',
		data: query
	})
}

/**
 * @describe 停用、恢复监管机构
 * @param regId 机构id
 * @param isStoped 是否停用 1-是 0-否
 */
export function stopRegulator(query) {
	return request({
		url: 'reg/stopRegulator.do',
		method: 'POST',
		data: query
	})
}

/**
 * @describe 监管机构-地区迁移
 * @param regId 机构id
 * @param targetAreaCode 目标地区
 */
export function changeRegionForReg(query) {
	return request({
		url: 'reg/changeRegionForReg.do',
		method: 'POST',
		data: query
	})
}

// ----------------- 监管人员 ---------------------


/**
 * @describe 获取某个监管机构下的监管人员
 * @param regId 机构id
 */
export function getRegWorkersByRegId(query) {
	return request({
		url: 'reg/getRegWorkersByRegId.do',
		method: 'GET',
		params: query
	})
}

/**
 * @describe 获取一个监管人员
 * @param regWorkerId 机构人员Id
 */
export function getOneRegulatorWorker(query) {
	return request({
		url: 'reg/getOneRegulatorWorker.do',
		method: 'GET',
		params: query
	})
}


/**
 * @describe 新增一个监管人员
 * @param regId 监管机构id（仅新增传）
 * @param workerName 人员名称
 * @param mobile 电话
 * @param idCard 身份证
 */
export function saveRegulatorWorker(query) {
	return request({
		url: 'reg/saveRegulatorWorker.do',
		method: 'POST',
		data: query
	})
}


/**
 * @describe 修改一个监管人员
 * @param regWorkerId 监管人员id（仅修改传）
 * @param 同上
 */
export function editRegulatorWorker(query) {
	return request({
		url: 'reg/editRegulatorWorker.do',
		method: 'POST',
		data: query
	})
}


/**
 * @describe 删除一个监管人员
 * @param regWorkerId
 */
export function delRegulatorWorker(query) {
	return request({
		url: 'reg/delRegulatorWorker.do',
		method: 'POST',
		data: query
	})
}

/**
 * @describe 停用、恢复监管人员
 * @param regWorkerId 机构人员Id
 * @param isStoped 是否停用 1-是 0-否
 */
export function stopRegulatorWorker(query) {
	return request({
		url: 'reg/stopRegulatorWorker.do',
		method: 'POST',
		data: query
	})
}


// -------------------------- 检测 --------------------------------
/**
 * @describe 分页查看检测记录
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param entName 企业名称
 * @param checkOrgName 监管机构名称
 * @param productName 产品名称
 * @param entProductId 企业产品id
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageCheck(query) {
	return request({
		url: 'reg/pageCheck.do',
		method: 'GET',
		params: query
	})
}


/**
 * @describe 获取一个检测记录
 * @param checkId
 */
export function getOneCheck(query) {
	return request({
		url: 'reg/getOneCheck.do',
		method: 'GET',
		params: query
	})
}


/**
 * @describe 新增一个检测记录
 * @param checkTime 检测时间
 * @param entId 企业id
 * @param regId 监管机构id
 * @param entProductId 企业产品id
 * @param contents 检测记录内容
 * @param image1 图片1
 * @param image2 图片2
 * @param image3 图片3
 * @param result 结果 1-合格 2-基本合格 0-不合格
 * @param workerIds 监管人员id列表
 * @param checkType 检测类型 1-企业自检 2-机构代检 3-第三方检测
 */
export function saveCheck(query) {
	return request({
		url: 'reg/saveCheck.do',
		method: 'POST',
		data: query,
		noTrans: true
	})
}

/**
 * @describe 修改一个检测记录
 * @param checkId
 * @param 同上
 */
export function editCheck(query) {
	return request({
		url: 'reg/editCheck.do',
		method: 'POST',
		data: query,
		noTrans: true
	})
}


/**
 * @describe 删除一个检测记录
 * @param checkId
 */
export function delCheck(query) {
	return request({
		url: 'reg/delCheck.do',
		method: 'POST',
		data: query
	})
}

// -------------------------------- 巡查 -------------------------------
/**
 * @describe 分页查看检测记录
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param entName 企业名称
 * @param regName 监管机构名称
 * @param industryId
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pagePatrol(query) {
	return request({
		url: 'reg/pagePatrol.do',
		method: 'GET',
		params: query
	})
}


/**
 * @describe 获取一个巡查记录
 * @param patrolId
 */
export function getOnePatrol(query) {
	return request({
		url: 'reg/getOnePatrol.do',
		method: 'GET',
		params: query
	})
}

/**
 * @describe 获取一个巡查记录（有巡查详情的） - 用于新增
 * @param patrolObjType  1-生产基地 2-农资店 3-畜禽养殖基地
 */
export function getOnePatrolForAdd(query) {
	return request({
		url: 'reg/getOnePatrolForAdd.do',
		method: 'GET',
		params: query
	})
}

/**
 * @describe 获取一个巡查记录（有巡查详情的）- 用于修改）
 * @param patrolId
 */
export function getOnePatrolForEdit(query) {
	return request({
		url: 'reg/getOnePatrolForEdit.do',
		method: 'GET',
		params: query
	})
}


/**
 * @describe 新增一个巡查记录
 * @param patrolTime 检测时间
 * @param entId 企业id
 * @param regId 监管机构id
 * @param contents 检测记录内容
 * @param image1 图片1
 * @param image2 图片2
 * @param image3 图片3
 * @param result 结果  1-合格 2-基本合格 0-不合格
 * @param regWorkerIds 监管人员id列表
 * @param signature 签名
 */
export function savePatrol(query) {
	return request({
		url: 'reg/savePatrol.do',
		method: 'POST',
		data: query,
		noTrans: true
	})
}


/**
 * @describe 修改一个检测记录
 * @param patrolId
 * @param 同上
 */
export function editPatrol(query) {
	return request({
		url: 'reg/editPatrol.do',
		method: 'POST',
		data: query,
		noTrans: true
	})
}


/**
 * @describe 删除一个巡查记录
 * @param patrolId
 */
export function delPatrol(query) {
	return request({
		url: 'reg/delPatrol.do',
		method: 'POST',
		data: query
	})
}

// -------------检测和巡查统计
/**
 * 按地区统计检测
 * @param query
 * @returns {*}
 */
export function statCheckInfoWithObjCountByArea(query){
	return request({
		url: 'stat/statCheckInfoWithObjCountByArea.do',
		method: 'POST',
		data: query
	})
}
